export default __webpack_public_path__ + "static/media/portfolio-dnf-icon.d75f8e14.svg";